import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';
import { ImagenesProvider } from '../imagenes/imagenes';

/*
  Generated class for the PatrocinadoresProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PatrocinadoresProvider {

  private api: string = "";

  constructor(public http: Http, public global: GlobalProvider, public imagenes: ImagenesProvider) {
    this.api = this.global.api;
    console.log('Hello PatrocinadoresProvider Provider');
  }

  // Elimina un patrocinador
  public delete(nclave): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "patrocinadores",
      "clave": nclave,
    };

    return this.http.post(this.api + "apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Inserta un nuevo patrocinador
  public insert(congreso, patrocinador): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    patrocinador.clavecongreso = congreso.clave;
    patrocinador.guid_enlace = this.newGuid();
    let parametros = {
      "token": this.global.token,
      "tabla": "patrocinadores",
      "parametros": patrocinador,
      "clavecongreso": congreso.clave
    };


    return this.http.post(this.api + "apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public update(congreso, patrocinador): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "patrocinadores",
      "clave": patrocinador.clave,
      "parametros": patrocinador,
      "clavecongreso": congreso.clave
    };

    return this.http.post(this.api + "apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();

        return respuesta[0];
      }
    ).catch(this.handleError);
  }


  // Devuelve todos los poenentes de un congreso
  /* public all(clavecongreso): Observable<any> {
  
     let headers = new Headers({ 'Content-Type': 'application/json' });
     let options = new RequestOptions({ headers: headers });
     let parametros ={
       "token":this.global.token,
       "tabla":"patrocinadores",
       "campofiltro":"clavecongreso",
       "valorfiltro": clavecongreso,
       "campoorden": "orden"
     };
   
     return this.http.post(this.api+"apigen/list.php", parametros, options).map(
       (response) => {
       
         return response.json();
         
       }
     ).catch(this.handleError);
   }*/
  public all(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };

    return this.http.post(this.api + "patrocinadores/lista.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  public carga_patrocinador(clave): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clave": clave
    };

    return this.http.post(this.api + "patrocinadores/ficha_patrocinador.php", parametros, options).map(
      (response) => {

        var respuesta = response.json();

        return respuesta[0];

      }
    ).catch(this.handleError);
  }
  public allimagen(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };
    console.log(parametros);
    return this.http.post(this.api + "patrocinadores/listaimagen.php", parametros, options).map(
      (response) => {
        //  var patrocinadoresx = response.json();
        console.log(response);
        return response.json();
        /*var length = patrocinadoresx.length;
       
       for (var i = 0; i < length; i++) {
         var im = patrocinadoresx[i].imagen;
 console.log(im);
         if (im) {
           this.imagenes.convierte2(clavecongreso, patrocinadoresx[i].imagen, i).subscribe(data => {
             patrocinadoresx[data.id].imagen = data.imagen;
 console.log(patrocinadoresx[data.id]);
               //window.localStorage.setItem('patricinadoresstemp', JSON.stringify(this.patrocinadores));
           })
         }else{
          // window.localStorage.setItem('patricinadoresstemp', JSON.stringify(this.patrocinadores));
         }
 
       };
       if(i == length){
       
       }*/


      }
    ).catch(this.handleError);
  }

  public ordena(congreso, patrocinadores): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "patrocinadores",
      "parametros": patrocinadores
    };

    return this.http.post(this.api + "apigen/orden.php", parametros, options).map(
      (response) => {

        return response.json();
      }
    ).catch(this.handleError);
  }
  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    // console.error(errMsg);
    //  alert(errMsg);
    return Observable.throw(errMsg);
  }
  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/patrocinadores/patrocinadores.ts